module.exports = __webpack_public_path__ + "img/305-0143e5.png";